// import { DefaultRouteReuseStrategy } from '@angular/router/src/router';
// import { ActivatedRouteSnapshot } from '@angular/router';
//
// export class CustomRouteReuseStrategy extends DefaultRouteReuseStrategy {
//   shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//     let name = future.component && (<any>future.component).name;
//     return super.shouldReuseRoute(future, curr) && name !== 'DetailSameComponent';
//   }
// }


import {RouteReuseStrategy} from '@angular/router/';
import {ActivatedRouteSnapshot, DetachedRouteHandle} from '@angular/router';
import {Injectable} from '@angular/core';


// export class DefaultRouteReuseStrategy implements RouteReuseStrategy {
//   shouldDetach(route: ActivatedRouteSnapshot): boolean { return false; }
//   store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void { }
//   shouldAttach(route: ActivatedRouteSnapshot): boolean { return false; }
//   retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle |null { return null; }
//   shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//     return future.routeConfig === curr.routeConfig;
//   }
// }

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private handlers: { [key: string]: DetachedRouteHandle } = {};


  constructor() {

  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    let k = route.url.join("/") || route.parent.url.join("/");
    // console.log('shouldDetach', k)
    return true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    let k = route.url.join("/") || route.parent.url.join("/");
    // console.log('store', k)
    if(k.indexOf('search') != -1) {
      this.handlers[k] = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // console.log('shouldAttach', route.url.join("/") || route.parent.url.join("/"))
    return !!this.handlers[route.url.join("/") || route.parent.url.join("/")];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.handlers[route.url.join("/") || route.parent.url.join("/")];
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/custom-route-reuse-strategy.ts